import { parseGraphParams } from "./graphParams";
import { parseMultiTimeMode } from "./buildMultiTimeGraphParams";

/** Minimal shape of a view graph element needed to classify it. */
export interface GraphElementLike {
  id?: string | null;
  graph_mode?: string | null;
  graph_tags_param?: string | null;
}

/** A graph and the indices of its CURRENT multi-time plots. */
export interface CurrentMultiTimeSelection {
  id: string;
  plotIndices: number[];
}

/**
 * For each embedded view graph, the indices of its CURRENT
 * (`CURRENT_MULTITIME_PLOT_MODE`) plots — the only plots whose data keeps
 * changing as a replay advances (their "current" window tracks the replay
 * position). The replay poll re-fetches just these plots, leaving the graph's
 * static RELATIVE/HISTORICAL plots untouched. Graphs with no CURRENT plot are
 * omitted. Plot index = param `plot[i]` order (== series index used by
 * `merge_graph_series`). CURRENT detection mirrors the tooltip's
 * `parseMultiTimeMode` (empty/unknown mode defaults to CURRENT).
 */
export function currentMultiTimePlotSelections(
  elements: GraphElementLike[],
): CurrentMultiTimeSelection[] {
  const out: CurrentMultiTimeSelection[] = [];
  for (const el of elements) {
    if (!el.id || el.graph_mode !== "multiTime" || !el.graph_tags_param) continue;
    const plots = parseGraphParams(el.graph_tags_param).plots;
    const plotIndices: number[] = [];
    plots.forEach((p, i) => {
      if (parseMultiTimeMode(p.multitimeMode) === "CURRENT") plotIndices.push(i);
    });
    if (plotIndices.length > 0) out.push({ id: el.id, plotIndices });
  }
  return out;
}
